import "../assets/styles/component.css"

export default function ProductCard(props){


    return(
        <div className="product-container">
            <div className={`product-image-container text-container ${props.transitionClass}`} style={{width: "45%",
                minWidth: "280px"}}>
                <img src={props.src} alt={props.name}/>
            </div>
            <div className="product-text-container">
                <h2 className={`font-semibold text-advise-color 
                                text-container ${props.transitionClass}`}
                    style={{fontSize: "1.8rem"}}>{props.name}</h2>
                <p className={`text-container ${props.transitionClass}`}
                    style={{fontSize: "1.1rem", textAlign: "justify", marginTop: "10px"}}>
                        {props.description}
                </p>
                {props.link != null ? 
                    <div className='sm:flex sm:flex-row-reverse' 
                            style={{"paddingTop": "20px", "color": "white"}}>
                        <a href={props.link} className="bg-blue-400 text-white-900 hover:bg-blue-300 
                        py-3 px-12 rounded-full text-lg font-semibold transition duration-300 
                        ease-in-out transform hover:scale-105 hover:shadow-lg hero-button">
                            Ver Demostración
                        </a>
                    </div>  
                : <></>}  
            </div>
        </div>
    )
}